import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import AdditionalInformation from "../../components/additional-information"
import {
  pageActu,
  pageActuAdditionalInfos,
  actualite,
  actualiteImg,
  actualiteTags,
  actualiteTaxo,
  actualiteTitle,
  actualiteContentFooter,
  actualiteContentFooterBack,
  socialPanelContainer,
} from "./styles/detailsActu.module.scss"
import ContentTransformer from "../../components/Transformers/content-transformer"
import PropTypes from "prop-types"
import {
  AdditionalInfos,
  ActuTaxo,
  ActuTitle,
  ActualiteFooterContainer,
} from "./styled-components/actualite-styled"
import TransitionFade from "../../components/transition-fade"
import FadeIn from "react-fade-in"
import Ariane from "../../components/Ariane/ariane"
import SocialPanel from "../../components/SocialMedias/social-panel"
import EditButton from "../../components/EditButton/edit-button"
import { LightBoxImage } from "../../components/LightBoxImage/light-box-image"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeActualites(path: { alias: { eq: $slug } }) {
      ...ActualiteItem
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const ActualiteTemplate = ({ data, location }) => {
  const nodeActualites = data.nodeActualites
  const allTaxos = nodeActualites.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout isDetail={true}>
      <SEO
        title={nodeActualites.title}
        description={
          "Dans cette page, vous découvrez l'actualité suivante : " +
          nodeActualites.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          nodeActualites.relationships?.field_image_actus?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <Ariane
        pageNameLink="/actualites"
        pageName="Toutes les actualités"
        isDetail={true}
        postName={nodeActualites.title}
      />
      <FadeIn delay={150}>
        <section className={pageActu}>
          <ActualiteContent actu={nodeActualites} />
          <ActualiteContentFooter
            actu={nodeActualites}
            location={location.href}
          />
        </section>
        <ActualiteInfos actu={nodeActualites} />
      </FadeIn>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const ActualiteContent = ({ actu }) => {
  return (
    <article className={actualite}>
      <div className={actualiteImg}>
        <EditButton link={"/node/" + actu.drupal_internal__nid + "/edit"} />
        {actu.relationships?.field_image_actus?.localFile && (
          <LightBoxImage
            type={"node"}
            node={{
              alt: actu.field_image_actus.alt,
              file: actu.relationships.field_image_actus.localFile,
            }}
          />
        )}
        {actu.relationships.field_taxonomie_thematique && (
          <div className={actualiteTags} role={"list"}>
            {actu.relationships.field_taxonomie_thematique.map((taxo) => (
              <ActuTaxo
                key={taxo.name}
                className={actualiteTaxo}
                role={"listitem"}
              >
                <TransitionFade link={taxo.path.alias}>
                  {taxo.name}
                </TransitionFade>
              </ActuTaxo>
            ))}
          </div>
        )}
      </div>
      <ActuTitle className={actualiteTitle}>{actu.title}</ActuTitle>
      {actu.body && <ContentTransformer content={actu.body.processed} />}
    </article>
  )
}

//-----------------------Child component/Content---------------------------//

//-----------------------Child component/ContentFooter---------------------------//

const ActualiteContentFooter = ({ actu, location }) => (
  <>
    <ActualiteFooterContainer className={actualiteContentFooter}>
      <div className={actualiteContentFooterBack}>
        <TransitionFade
          arialabel="Retour à la liste des actualités"
          link="/actualites"
        >
          Retour à la liste des actualités
        </TransitionFade>
      </div>
      <p>posté le {actu.field_date_de_publication || actu.created}</p>
    </ActualiteFooterContainer>
    <div className={socialPanelContainer}>
      <SocialPanel location={location} postData={actu} />
    </div>
  </>
)

//-----------------------Child component/ContentFooter---------------------------//

//-----------------------Child component/Infos---------------------------//

const ActualiteInfos = ({ actu }) => (
  <>
    {actu.field_infos_complementaires && (
      <AdditionalInfos className={pageActuAdditionalInfos}>
        <AdditionalInformation node={actu} />
      </AdditionalInfos>
    )}
  </>
)

//-----------------------Child component/Infos---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

ActualiteTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
ActualiteContent.propTypes = {
  actu: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
ActualiteInfos.propTypes = {
  actu: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
ActualiteContentFooter.propTypes = {
  actu: PropTypes.object.isRequired,
  colors: PropTypes.object,
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default ActualiteTemplate
